/* RAAVA Craftoluxe — global.js
   Vanilla, no framework. Progressive enhancement. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var routes = window.Shopify && window.Shopify.routes ? window.Shopify.routes : { root: '/' };
  var money = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'INR';

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }
  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
        style: 'currency', currency: money, maximumFractionDigits: 0
      }).format(cents / 100);
    } catch (e) { return '₹' + Math.round(cents / 100); }
  }
  function fetchJSON(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } }, opts || {}))
      .then(function (r) { return r.json(); });
  }
  function trapFocus(container, firstFocus) {
    var focusables = $all('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', container);
    var first = firstFocus || focusables[0];
    var last = focusables[focusables.length - 1];
    if (first) first.focus();
    function handler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); if (last) last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); if (first) first.focus(); }
    }
    container.addEventListener('keydown', handler);
    return function () { container.removeEventListener('keydown', handler); };
  }

  /* ---------- pub/sub ---------- */
  var events = {};
  window.RAAVA = {
    on: function (name, fn) { (events[name] = events[name] || []).push(fn); },
    emit: function (name, data) { (events[name] || []).forEach(function (fn) { fn(data); }); }
  };

  /* ---------- sticky header ---------- */
  function initStickyHeader() {
    var wrap = $('.header-wrap');
    if (!wrap) return;
    var sentinel = document.createElement('div');
    wrap.parentNode.insertBefore(sentinel, wrap);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        wrap.classList.toggle('is-stuck', !entries[0].isIntersecting);
      }, { rootMargin: '0px' }).observe(sentinel);
    }
  }

  /* ---------- drawers ---------- */
  var openDrawer = null, releaseTrap = null, lastTrigger = null;
  function drawerOpen(el, trigger) {
    if (!el) return;
    if (openDrawer) drawerClose();
    openDrawer = el;
    lastTrigger = trigger || document.activeElement;
    el.classList.add('is-open');
    el.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    el.setAttribute('aria-hidden', 'false');
    releaseTrap = trapFocus(el.querySelector('.drawer__panel') || el);
    RAAVA.emit('drawer:open', el.id);
  }
  function drawerClose() {
    if (!openDrawer) return;
    var el = openDrawer;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (releaseTrap) releaseTrap();
    setTimeout(function () { el.setAttribute('hidden', ''); }, 350);
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
    openDrawer = null;
    RAAVA.emit('drawer:close', el.id);
  }
  function initDrawers() {
    on(document, 'click', function (e) {
      var opener = e.target.closest('[data-drawer-open]');
      if (opener) {
        e.preventDefault();
        drawerOpen(document.getElementById(opener.getAttribute('data-drawer-open')), opener);
        return;
      }
      if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__overlay')) {
        drawerClose();
      }
    });
    on(document, 'keydown', function (e) { if (e.key === 'Escape' && openDrawer) drawerClose(); });
  }

  /* ---------- mega menu (keyboard + touch) ---------- */
  function initMegaMenu() {
    $all('.header__nav > li.has-mega').forEach(function (li) {
      var link = li.querySelector(':scope > a');
      var mega = li.querySelector('.mega');
      if (!link || !mega) return;
      link.setAttribute('aria-expanded', 'false');
      function close() { li.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); }
      function open() { li.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); }
      on(link, 'click', function (e) {
        if (window.matchMedia('(hover: none)').matches || window.innerWidth <= 989) {
          e.preventDefault();
          li.classList.contains('is-open') ? close() : open();
        }
      });
      on(li, 'mouseleave', close);
      on(li, 'focusout', function (e) { if (!li.contains(e.relatedTarget)) close(); });
      on(li, 'keydown', function (e) { if (e.key === 'Escape') { close(); link.focus(); } });
    });
  }

  /* ---------- mobile nav accordion ---------- */
  function initMobileNav() {
    var nav = $('#MobileNav');
    if (!nav) return;
    on(nav, 'click', function (e) {
      var toggle = e.target.closest('.m-nav__toggle');
      if (!toggle) return;
      var sub = toggle.nextElementSibling;
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      if (sub) sub.hidden = expanded;
    });
  }

  /* ---------- announcement rotator ---------- */
  function initAnnouncement() {
    $all('[data-announcement]').forEach(function (bar) {
      var slides = $all('.announcement__slide', bar);
      if (slides.length < 2) return;
      var i = 0, timer;
      var autoplay = bar.getAttribute('data-autoplay') === 'true' && !reduceMotion;
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, idx) { s.hidden = idx !== i; });
      }
      function next() { show(i + 1); }
      function prev() { show(i - 1); }
      show(0);
      on($('.announcement__arrow--next', bar), 'click', next);
      on($('.announcement__arrow--prev', bar), 'click', prev);
      if (autoplay) {
        timer = setInterval(next, 5000);
        on(bar, 'mouseenter', function () { clearInterval(timer); });
        on(bar, 'mouseleave', function () { timer = setInterval(next, 5000); });
      }
    });
  }

  /* ---------- slideshow ---------- */
  function initSlideshows() {
    $all('[data-slideshow]').forEach(function (root) {
      var track = $('.slideshow__track', root);
      var slides = $all('.slideshow__slide', track);
      if (!track || slides.length < 2) return;
      var dotsWrap = $('.slideshow__dots', root);
      var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduceMotion;
      var interval = parseInt(root.getAttribute('data-interval') || '6', 10) * 1000;
      var current = 0, timer;

      if (dotsWrap) {
        slides.forEach(function (_, idx) {
          var b = document.createElement('button');
          b.className = 'slideshow__dot';
          b.setAttribute('aria-label', 'Slide ' + (idx + 1));
          b.addEventListener('click', function () { go(idx); });
          dotsWrap.appendChild(b);
        });
      }
      function update() {
        if (dotsWrap) $all('.slideshow__dot', dotsWrap).forEach(function (d, idx) {
          d.setAttribute('aria-current', idx === current ? 'true' : 'false');
        });
      }
      function go(idx) {
        current = (idx + slides.length) % slides.length;
        track.scrollTo({ left: slides[current].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        update();
      }
      on($('.slideshow__arrow--next', root), 'click', function () { go(current + 1); stopAuto(); });
      on($('.slideshow__arrow--prev', root), 'click', function () { go(current - 1); stopAuto(); });
      function startAuto() { if (autoplay) timer = setInterval(function () { go(current + 1); }, interval); }
      function stopAuto() { clearInterval(timer); }
      on(root, 'mouseenter', stopAuto);
      on(root, 'mouseleave', startAuto);
      var scrollTO;
      on(track, 'scroll', function () {
        clearTimeout(scrollTO);
        scrollTO = setTimeout(function () {
          current = Math.round(track.scrollLeft / track.clientWidth);
          update();
        }, 100);
      });
      update();
      startAuto();
    });
  }

  /* ---------- quantity inputs ---------- */
  function initQuantity() {
    on(document, 'click', function (e) {
      var btn = e.target.closest('.quantity button');
      if (!btn) return;
      var input = btn.parentNode.querySelector('input');
      if (!input) return;
      var step = btn.getAttribute('data-qty') === 'down' ? -1 : 1;
      var min = parseInt(input.min || '0', 10);
      var val = (parseInt(input.value, 10) || 0) + step;
      input.value = Math.max(min, val);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- accordions / collapsibles ---------- */
  function initAccordionSingle() {
    $all('[data-accordion-exclusive]').forEach(function (group) {
      on(group, 'toggle', function (e) {
        if (!e.target.open) return;
        $all('details[open]', group).forEach(function (d) { if (d !== e.target) d.open = false; });
      }, true);
    });
  }

  /* ---------- tabs ---------- */
  function initTabs() {
    $all('[data-tabs]').forEach(function (root) {
      var tabs = $all('[role="tab"]', root);
      var panels = $all('[role="tabpanel"]', root);
      function select(idx) {
        tabs.forEach(function (t, i) {
          t.setAttribute('aria-selected', i === idx ? 'true' : 'false');
          t.tabIndex = i === idx ? 0 : -1;
        });
        panels.forEach(function (p, i) { p.hidden = i !== idx; });
      }
      tabs.forEach(function (t, i) {
        on(t, 'click', function () { select(i); });
        on(t, 'keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); tabs[(i + 1) % tabs.length].focus(); select((i + 1) % tabs.length); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); var n = (i - 1 + tabs.length) % tabs.length; tabs[n].focus(); select(n); }
        });
      });
      select(0);
    });
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      $all('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $all('.reveal').forEach(function (el) { io.observe(el); });
  }

  /* ---------- facets auto-submit ---------- */
  function initFacets() {
    var forms = $all('form.facets');
    if (!forms.length) return;
    var debounceTO;
    function submit(form) {
      var params = new URLSearchParams(new FormData(form));
      var url = form.getAttribute('action') + '?' + params.toString();
      history.replaceState(null, '', url);
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['#ProductGrid', '.collection-toolbar__count', '.active-facets'].forEach(function (sel) {
          var incoming = doc.querySelector(sel), existing = document.querySelector(sel);
          if (incoming && existing) existing.replaceWith(incoming);
        });
        var openLabels = $all('.facets--bar .facets__group[open] > summary').map(function (s) { return s.textContent.trim(); });
        var incomingForms = doc.querySelectorAll('form.facets'), existingForms = document.querySelectorAll('form.facets');
        existingForms.forEach(function (f, i) { if (incomingForms[i]) f.replaceWith(incomingForms[i]); });
        $all('.facets--bar .facets__group').forEach(function (g) {
          var s = g.querySelector('summary');
          if (s && openLabels.indexOf(s.textContent.trim()) > -1) g.setAttribute('open', '');
        });
        initFacets();
      });
    }
    if (!document.documentElement.hasAttribute('data-facets-bar-bound')) {
      document.documentElement.setAttribute('data-facets-bar-bound', '');
      on(document, 'click', function (e) {
        $all('.facets--bar .facets__group[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
      });
    }
    forms.forEach(function (form) {
      on(form, 'input', function (e) {
        if (e.target.type === 'text' || e.target.type === 'number') return;
        submit(form);
      });
      on(form, 'change', function (e) {
        if (e.target.type === 'text' || e.target.type === 'number') { clearTimeout(debounceTO); debounceTO = setTimeout(function () { submit(form); }, 500); }
      });
      on(form, 'submit', function (e) { e.preventDefault(); submit(form); });
    });
  }

  /* ---------- add to cart + cart drawer ---------- */
  function refreshCartUI() {
    return fetch(routes.root + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data['cart-drawer']) {
          var frag = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
          var incoming = frag.querySelector('#CartDrawer .drawer__inner') || frag.querySelector('#CartDrawer');
          var existing = document.querySelector('#CartDrawer .drawer__inner') || document.querySelector('#CartDrawer');
          if (incoming && existing) existing.innerHTML = incoming.innerHTML;
        }
        if (data['cart-icon-bubble']) {
          var b = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html').querySelector('.cart-count');
          var cur = document.querySelector('.cart-count');
          if (b && cur) cur.replaceWith(b);
          else if (b && !cur) { var link = document.querySelector('[data-cart-link]'); if (link) link.appendChild(b); }
        }
        RAAVA.emit('cart:updated');
      });
  }

  function initProductForms() {
    on(document, 'submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.innerHTML = form.getAttribute('data-adding-text') || 'Adding…'; }
      var fd = new FormData(form);
      fd.append('sections', 'cart-drawer,cart-icon-bubble');
      fetch(routes.root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { showFormError(form, res.description || res.message); return; }
          return refreshCartUI().then(function () {
            drawerOpen(document.getElementById('CartDrawer'), btn);
          });
        })
        .catch(function () { showFormError(form, 'Something went wrong. Please try again.'); })
        .finally(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.innerHTML = original; } });
    });
  }
  function showFormError(form, msg) {
    var box = form.querySelector('.form-status') || (function () {
      var d = document.createElement('div'); d.className = 'form-status form-status--error'; form.prepend(d); return d;
    })();
    box.textContent = msg;
  }

  function initCartMutations() {
    on(document, 'click', function (e) {
      var remove = e.target.closest('[data-cart-remove]');
      if (remove) { e.preventDefault(); changeLine(remove.getAttribute('data-cart-remove'), 0); }
    });
    on(document, 'change', function (e) {
      var qty = e.target.closest('[data-cart-qty]');
      if (qty) changeLine(qty.getAttribute('data-cart-qty'), parseInt(qty.value, 10));
    });
    on(document, 'change', function (e) {
      var wrap = e.target.closest('[data-gift-wrap-toggle]');
      if (!wrap) return;
      var variantId = wrap.getAttribute('data-variant-id');
      if (e.target.checked) {
        fetch(routes.root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _gift_wrap: 'true' } }], sections: 'cart-drawer,cart-icon-bubble' })
        }).then(refreshCartUI);
      } else {
        changeLine(wrap.getAttribute('data-line-key'), 0);
      }
    });
  }
  function changeLine(key, quantity) {
    fetchJSON(routes.root + 'cart/change.js', {
      method: 'POST',
      body: JSON.stringify({ id: key, quantity: quantity, sections: 'cart-drawer,cart-icon-bubble' })
    }).then(function () { return refreshCartUI(); });
  }

  /* ---------- product variant selection ---------- */
  function initVariantPickers() {
    $all('[data-variant-picker]').forEach(function (picker) {
      var form = picker.closest('form') || document.querySelector('form[action*="/cart/add"]');
      var productHandle = picker.getAttribute('data-product-handle');
      var section = picker.getAttribute('data-section');
      on(picker, 'change', function () {
        var opts = $all('select, input:checked', picker).map(function (el) { return el.value; });
        var url = routes.root + 'products/' + productHandle + '?section_id=' + section;
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          // Match variant via embedded JSON
          var dataEl = doc.querySelector('[data-variants-json]');
          if (!dataEl) return;
          var variants = JSON.parse(dataEl.textContent);
          var match = variants.find(function (v) {
            return v.options.every(function (o, i) { return o === opts[i]; });
          });
          updateVariant(match, doc, section);
        });
      });
    });
  }
  function updateVariant(variant, doc, section) {
    var priceEl = document.querySelector('#Price-' + section);
    var incomingPrice = doc.querySelector('#Price-' + section);
    if (priceEl && incomingPrice) priceEl.replaceWith(incomingPrice);
    var idInput = document.querySelector('#VariantId-' + section);
    var btn = document.querySelector('#AddToCart-' + section);
    if (variant) {
      if (idInput) idInput.value = variant.id;
      var url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
      if (btn) {
        btn.disabled = !variant.available;
        btn.querySelector('span').textContent = variant.available ? btn.getAttribute('data-add-text') : btn.getAttribute('data-soldout-text');
      }
    } else if (btn) {
      btn.disabled = true;
      btn.querySelector('span').textContent = btn.getAttribute('data-unavailable-text') || 'Unavailable';
    }
    RAAVA.emit('variant:change', variant);
  }

  /* ---------- product gallery ---------- */
  function initGallery() {
    $all('[data-gallery]').forEach(function (gallery) {
      var main = $('.product-gallery__main img', gallery);
      on(gallery, 'click', function (e) {
        var thumb = e.target.closest('.product-gallery__thumb');
        if (thumb && main) {
          var full = thumb.getAttribute('data-full');
          if (full) { main.src = full; main.srcset = ''; }
          $all('.product-gallery__thumb', gallery).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
          thumb.setAttribute('aria-current', 'true');
          return;
        }
        if (e.target.closest('[data-zoom]') && main) openLightbox(main.src);
      });
    });
  }
  function openLightbox(src) {
    var box = document.createElement('div');
    box.className = 'drawer is-open';
    box.style.cssText = 'z-index:200;';
    box.innerHTML = '<div class="drawer__overlay" data-drawer-close style="opacity:1"></div>' +
      '<img src="' + src + '" alt="" style="position:absolute;inset:0;margin:auto;max-width:92vw;max-height:92vh;object-fit:contain">' +
      '<button data-drawer-close aria-label="Close" style="position:absolute;top:1rem;right:1rem;color:#fff;font-size:2rem;z-index:2">&times;</button>';
    document.body.appendChild(box);
    document.body.style.overflow = 'hidden';
    function close() { box.remove(); document.body.style.overflow = ''; }
    box.addEventListener('click', function (e) { if (e.target.hasAttribute('data-drawer-close')) close(); });
    document.addEventListener('keydown', function esc(e) { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); } });
  }

  /* ---------- delivery date constraints ---------- */
  function initDeliveryDate() {
    $all('[data-delivery-date]').forEach(function (input) {
      var lead = parseInt(input.getAttribute('data-lead-days') || '0', 10);
      var disabled = (input.getAttribute('data-disabled-weekdays') || '')
        .split(',').map(function (s) { return parseInt(s, 10); }).filter(function (n) { return !isNaN(n); });
      var min = new Date();
      min.setDate(min.getDate() + lead);
      input.min = min.toISOString().slice(0, 10);
      on(input, 'input', function () {
        if (!input.value) { input.setCustomValidity(''); return; }
        var d = new Date(input.value + 'T00:00');
        if (disabled.indexOf(d.getDay()) !== -1) {
          input.setCustomValidity('That day is unavailable for delivery.');
          input.reportValidity();
        } else {
          input.setCustomValidity('');
        }
      });
    });
  }

  /* ---------- character counters ---------- */
  function initCharCounters() {
    $all('[data-char-max]').forEach(function (field) {
      var max = parseInt(field.getAttribute('data-char-max'), 10);
      var counter = document.createElement('span');
      counter.className = 'field__count';
      field.parentNode.style.position = 'relative';
      field.parentNode.appendChild(counter);
      function update() { counter.textContent = (field.value.length) + '/' + max; }
      on(field, 'input', update);
      update();
    });
  }

  /* ---------- sticky add-to-cart ---------- */
  function initStickyAtc() {
    var bar = $('.sticky-atc');
    var form = $('.product-form');
    if (!bar || !form || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(form);
    on(bar, 'click', function (e) {
      if (e.target.closest('[data-sticky-add]')) {
        e.preventDefault();
        form.querySelector('[type="submit"]').click();
      }
    });
  }

  /* ---------- product recommendations (async) ---------- */
  function initRecommendations() {
    var el = $('[data-recommendations]');
    if (!el || !el.getAttribute('data-url')) return;
    fetch(el.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector('[data-recommendations]');
        if (incoming && incoming.querySelector('.grid')) el.innerHTML = incoming.innerHTML;
        else el.hidden = true;
      })
      .catch(function () { el.hidden = true; });
  }

  /* ---------- recently viewed ---------- */
  var RV_KEY = 'raava:recently-viewed';
  function trackRecentlyViewed() {
    var el = $('[data-current-product]');
    if (!el) return;
    var handle = el.getAttribute('data-current-product');
    var list = [];
    try { list = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) {}
    list = [handle].concat(list.filter(function (h) { return h !== handle; })).slice(0, 12);
    try { localStorage.setItem(RV_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function renderRecentlyViewed() {
    var holder = $('[data-recently-viewed]');
    if (!holder) return;
    var list = [];
    try { list = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) {}
    var current = holder.getAttribute('data-exclude');
    list = list.filter(function (h) { return h !== current; }).slice(0, parseInt(holder.getAttribute('data-limit') || '4', 10));
    if (!list.length) { holder.closest('[data-recently-viewed-section]') && (holder.closest('[data-recently-viewed-section]').hidden = true); return; }
    var q = list.map(function (h) { return 'handle:' + h; }).join(' OR ');
    var sectionId = holder.getAttribute('data-section');
    fetch(routes.root + 'search?type=product&q=' + encodeURIComponent(q) + '&section_id=' + sectionId)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.querySelector('[data-recently-viewed-grid]');
        if (grid) holder.innerHTML = grid.innerHTML;
        else if (holder.closest('[data-recently-viewed-section]')) holder.closest('[data-recently-viewed-section]').hidden = true;
      });
  }

  /* ---------- localization disclosure ---------- */
  function initLocalization() {
    $all('[data-localization]').forEach(function (form) {
      on(form, 'change', function (e) {
        if (e.target.tagName === 'SELECT') form.submit();
      });
    });
  }

  /* ---------- predictive search (light) ---------- */
  function initPredictiveSearch() {
    var input = $('[data-predictive-search-input]');
    var results = $('[data-predictive-search-results]');
    if (!input || !results) return;
    var to;
    on(input, 'input', function () {
      clearTimeout(to);
      var term = input.value.trim();
      if (term.length < 2) { results.hidden = true; return; }
      to = setTimeout(function () {
        fetch(routes.root + 'search/suggest?q=' + encodeURIComponent(term) +
          '&resources[type]=product,collection,article,page&resources[limit]=6&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var incoming = doc.querySelector('[data-predictive-search-results]');
            if (incoming) { results.innerHTML = incoming.innerHTML; results.hidden = false; }
          });
      }, 250);
    });
    on(document, 'click', function (e) {
      if (!e.target.closest('[data-predictive-search]')) results.hidden = true;
    });
  }

  /* ---------- init ---------- */
  function init() {
    initStickyHeader();
    initDrawers();
    initMegaMenu();
    initMobileNav();
    initAnnouncement();
    initSlideshows();
    initQuantity();
    initAccordionSingle();
    initTabs();
    initReveal();
    initFacets();
    initProductForms();
    initCartMutations();
    initVariantPickers();
    initGallery();
    initStickyAtc();
    initDeliveryDate();
    initCharCounters();
    initLocalization();
    initPredictiveSearch();
    initRecommendations();
    trackRecentlyViewed();
    renderRecentlyViewed();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', init);
})();
